"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraceContext = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class TraceContext extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.pageTraceId = "";
        this.parentId = "";
    }
    schema() {
        return TraceContext.schema;
    }
    subject() {
        return TraceContext.subject;
    }
}
exports.TraceContext = TraceContext;
TraceContext.subject = "trace-context";
TraceContext.schema = {
    "type": "record",
    "name": "TraceContext",
    "namespace": "storyblocks.common",
    "fields": [
        {
            "name": "traceId",
            "type": "string"
        },
        {
            "name": "pageTraceId",
            "type": "string",
            "default": ""
        },
        {
            "name": "spanId",
            "type": "string"
        },
        {
            "name": "parentId",
            "type": "string",
            "default": ""
        }
    ]
};
//# sourceMappingURL=TraceContext.js.map